import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4 16.3077V17.5385M4 17.5385C4 18.1913 4.25934 18.8174 4.72097 19.279M4 17.5385L4.72097 19.279M4.72097 19.279C5.1826 19.7407 5.8087 20 6.46154 20M4.72097 19.279L6.46154 20M6.46154 20H17.5385M17.5385 20C18.1913 20 18.8174 19.7407 19.279 19.279M17.5385 20L18.5385 19.7877L19.279 19.279M19.279 19.279C19.7407 18.8174 20 18.1913 20 17.5385M19.279 19.279L20 17.5385M20 17.5385V16.3077M8.30769 10.7692L12 15.0769M12 15.0769L15.6923 10.7692M12 15.0769V4",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
